import { render, staticRenderFns } from "./AppDateLink.vue?vue&type=template&id=641d2d9a&"
import script from "./AppDateLink.vue?vue&type=script&lang=js&"
export * from "./AppDateLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports